import { Chip } from '@mui/material';
import { useOrderIssuesTotal } from '@/contexts/OrderIssuesTotalContext';

/** The Order Issues sidebar count, styled like the Item Issues one; nothing while there are none or the first read fails. */
export const OrderIssuesSidebarChip = () => {
  const { total } = useOrderIssuesTotal();
  if (total === 0) return null;
  const label = total.toLocaleString('en-US');
  return <Chip label={label} color='error' size='small' role='img' aria-label={`${label} open order issue${total === 1 ? '' : 's'}`} />;
};
